import {
  BellIcon,
  ChartBarIcon,
  ClipboardListIcon,
  CursorClickIcon,
  ChatAltIcon,
  DeviceMobileIcon,
} from "@heroicons/react/outline"

const features = [
  {
    name: "Live Digital Roll Call",
    description:
      "A simple and reliable digital roll call allows students to easily set their status as Accounted For or In Danger, all in real-time.",
    icon: ClipboardListIcon,
  },
  // {
  //   name: "Faculty Can Update The Roll Call",
  //   description:
  //     "Faculty authorized by school administrators to access the emergency dashboard are able to view and update students on the digital roll call.",
  //   icon: CursorClickIcon,
  // },
  {
    name: "Emails, Texts, & Calls",
    description:
      "When an emergency is declared, community members receive an alert through email, text, and call that can prompt them to set their status.",
    icon: ChatAltIcon,
  },
  {
    name: "Custom Messages & Alerts",
    description:
      "Have an update to convey during an emergency? With a click of a button a custom message can be sent instantly to all community members.",
    icon: BellIcon,
  },
  {
    name: "Emergency Statistics",
    description:
      "Want to see how many community members are accounted for, and by grade? The dashboard provides valuable statistics in real-time.",
    icon: ChartBarIcon,
  },
  // {
  //   name: "Available Across All Your Devices",
  //   description:
  //     "Access the emergency dashboard on your computer through the web app, and on your phone too. Both have the necessary features and both are fast and reliable.",
  //   icon: DeviceMobileIcon,
  // },
]
export default features
